<template>
  <load-page>
    <!--
    ============================================================================
    Tabs
    ============================================================================
    -->
    <template slot="tabs">
      <b-tab :title="$t('changePassword.tabs.main')" active class="scrollable">
        <b-alert variant="danger" show v-if="error">
          {{ error }}
        </b-alert>
        <div class="padded">
          <string-form-field
            :label="$t('changePassword.fields.oldPassword')"
            required
            type="password"
            :error="findError('oldPassword')"
            v-model="oldPassword">
          </string-form-field>

          <string-form-field
            :label="$t('changePassword.fields.newPassword')"
            required
            type="password"
            :error="findError('newPassword')"
            v-model="newPassword">
          </string-form-field>

          <string-form-field
            :label="$t('changePassword.fields.confirmPassword')"
            required
            type="password"
            :error="findError('confirmPassword')"
            v-model="confirmPassword">
          </string-form-field>
        </div>
      </b-tab>
    </template>
    <!--
    ============================================================================
    Buttons
    ============================================================================
    -->
    <template slot="buttons">
      <b-button variant="cancel" class="float-left" @click.prevent="cancel()">
        {{ $t("common.cancel") }}
      </b-button>
      <b-button variant="save" @click.prevent="changePassword()">
        {{ $t("common.save") }}
      </b-button>
    </template>
  </load-page>
</template>
<script>
import { LoggedUserService } from "vue-template";
import HasErrorsMixin from 'vue-template/common/mixins/HasErrorsMixin';

export default {
  mixins: [HasErrorsMixin],

  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      error: null,
      validationErrors: null,
    };
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    // TODO handle errors
    async changePassword() {
      try {
        this.error = null;
        this.validationErrors = null;
        const result = await LoggedUserService.changePassword({
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          confirmPassword: this.confirmPassword,
        });
        console.log(result);
        this.$emit('password-changed', result);
      } catch (e) {
        console.error(e);
        switch (e.statusCode) {
          case 422:
            this.validationErrors = e.data;
            break;
          case 403:
            this.validationErrors = [
              {
                path: "oldPassword",
                message: e.data
              }
            ];
            break;
          default:
            this.error = this.$error2text(e.data);
        }
      }
    }
  }
};
</script>
